// extracted by mini-css-extract-plugin
export default {"input":"input-number_input__lSn8G","button":"input-number_button__gWsj6","dropdown":"input-number_dropdown__DjIo0","search":"input-number_search__T+yUa"};